import { render, staticRenderFns } from "./register-step.vue?vue&type=template&id=bade90c6&scoped=true&"
import script from "./register-step.vue?vue&type=script&lang=ts&"
export * from "./register-step.vue?vue&type=script&lang=ts&"
import style0 from "./register-step.vue?vue&type=style&index=0&id=bade90c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bade90c6",
  null
  
)

export default component.exports